import { useEffect, useState } from "react";

export default function RollingText({ text, className = "", testid }) {
  const [show, setShow] = useState(false);
  const chars = text.toUpperCase().split("");

  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) {
      setShow(true);
      return;
    }
    const t = setTimeout(() => setShow(true), 250);
    return () => clearTimeout(t);
  }, []);

  const replay = () => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;
    setShow(false);
    requestAnimationFrame(() => requestAnimationFrame(() => setShow(true)));
  };

  return (
    <span
      className={`roll-text ${className}`}
      aria-label={text}
      data-testid={testid}
      onMouseEnter={replay}
    >
      {chars.map((c, i) => (
        <span key={i} className="roll-box" aria-hidden="true">
          <span
            className="roll-glyph"
            style={{
              transform: show ? "translateY(0)" : "translateY(110%)",
              transitionDelay: `${i * 0.06}s`,
            }}
          >
            {c}
          </span>
        </span>
      ))}
    </span>
  );
}
